import React from "react"

const DarkTheme = ({ updateIsDarkTheme, isDarkTheme }) => {
    const handleClick = () => {
        updateIsDarkTheme(!isDarkTheme)
    }

    return (
        <>
            <div className="zip-download-wrapper" style={{ right: "50px" }}>
                <div className="zip-download-container" onClick={handleClick}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16M1 8a7 7 0 0 0 7 7 3.5 3.5 0 1 0 0-7 3.5 3.5 0 1 1 0-7 7 7 0 0 0-7 7"/>
                    </svg>
                </div>
            </div>
        </>
    );
}

export default DarkTheme;